import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/sections/Hero";
import { Transition } from "../components/sections/Transition";
import { EditorialMarquee } from "../components/sections/EditorialMarquee";
import { Features } from "../components/sections/Features";
import { Performance } from "../components/sections/Performance";
import { DeviceCategories } from "../components/sections/DeviceCategories";
import { Trust } from "../components/sections/Trust";
import { Process } from "../components/sections/Process";
import { FinalCTA } from "../components/sections/FinalCTA";
import { Location } from "../components/sections/Location";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      setTimeout(() => {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location.state]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Transition />
      <EditorialMarquee />
      <Features />
      <Performance />
      <DeviceCategories />
      <Trust />
      <Process />
      <FinalCTA />
      <Location />
    </main>
  );
}
